/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

import AuthService from 'services/API/Auth/AuthService.js';

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import Icon from '@mui/material/Icon';
import MuiLink from "@mui/material/Link";
import FormControlLabel from "@mui/material/FormControlLabel";


// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDInput from "common/components/MD/MDInput";
import MDButton from "common/components/MD/MDButton";
import Alert from '@mui/material/Alert';

// Authentication layout components
import BasicLayout from "layouts/BasicLayout";

// Images
//import bgImage from "common/assets/images/bg-sign-in-basic.png";
import bgImage from "common/assets/images/AU_fondo_login_farfiera.png";
import logo from "common/assets/images/logos/AU+UF_schermata_login_farfiera.png";
//import logo from "common/assets/images/logos/logo_icon.jpg";
import pulsanteEspositore from "common/assets/images/pulsante-espositore.png";
import pulsanteVisitatore from "common/assets/images/pulsante-visitatore.png";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

import { useMaterialUIController } from "common/context";
import { IconButton, InputAdornment } from "@mui/material";

function RegisterCard({ icon, who, action, to }) {
  return (
  <MDBox
  component={Link}
  to={to}
  display="flex"
  alignItems="center"
  gap={1.5}
  p={1.5}
  height="100%"
  borderRadius="lg"
  sx={({ palette: { brand, grey }, functions: { rgba } }) => ({
    border: `1px solid ${grey[300]}`,
    transition: "all .2s ease",
    "&:hover": {
      borderColor: brand.main,
      backgroundColor: rgba(brand.focus, 0.06),
      transform: "translateY(-2px)",
      boxShadow: `0 6px 16px ${rgba(brand.main, 0.18)}`,
    },
    "&:focus-visible": {
      outline: `2px solid ${brand.focus}`,
      outlineOffset: "2px",
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
      "&:hover": { transform: "none" },
    },
  })}
>
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="44px"
        height="44px"
        flexShrink={0}
        borderRadius="50%"
       sx={({ palette: { brand }, functions: { rgba } }) => ({
      backgroundColor: rgba(brand.focus, 0.15),
    })}
      >
         <Icon
      aria-hidden="true"
      sx={({ palette: { brand } }) => ({ color: brand.main, fontSize: "1.5rem !important" })}
    >{icon}</Icon>
      </MDBox>
      <MDBox lineHeight={1.2}>
        <MDTypography variant="caption" color="text" display="block">
          Sei un<b>{who}</b>?
        </MDTypography>
        <MDTypography variant="button" fontWeight="bold"    sx={({ palette: { brand } }) => ({ color: brand.focus })}>
          {action}  <span aria-hidden="true">→</span>
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
function Basic() {

  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPwd, setShowPwd] = useState(false);
  const [controller] = useMaterialUIController();

  let navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {

    //controller.setDarkMode(false);
    const savedUserid = localStorage.getItem('userid');
    const savedPassword = localStorage.getItem('password');
    if (savedUserid && savedPassword) {
      setUserid(savedUserid);
      setPassword(savedPassword);
      setRememberMe(true);
    }

  }, []);




  const handleSetRememberMe = () => {
    localStorage.setItem("rememberMe", !rememberMe);
    setRememberMe(!rememberMe);
  }






  async function handleClickLogin(e) {



    if (!checkAuthentication()) {
      console.log("chiamato login con userid =" + userid + " e password= " + password);
      await AuthService.login(userid, password, navigate)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
    }
    else { navigate(`/welcome`); }
  }

  function handleError(error) {
    console.log("ERROR IN LOGIN");
    console.log(error);
    setError(error);
    console.log('Error', error.message);

    /* if (error.response) {
       // The request was made and the server responded with a status code
       // that falls out of the range of 2xx
       console.log(error.response.data);
       //   console.log(error.response.status);
       //   console.log(error.response.headers);
 
     } else if (error.request) {
       // The request was made but no response was received
       // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
       // http.ClientRequest in node.js
       console.log(error.request);
     } else {
       // Something happened in setting up the request that triggered an Error
       console.log('Error', error.message);
     }*/

  }

  const checkAuthentication = () => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (token) {
      console.log("Utente autenticato con token:", token);

      if (AuthService.isTokenOk())
        return true;
      else return false;
    } else {
      console.log("Utente non autenticato.");
      return false;
    }
  };



  function handleResponse(response) {

    if (response?.error) {
      console.log("HANDLE RESPONSE CON ERRORI");
      setError(response.error);
      return { error: response.error };
    } else {
      console.log("HANDLE RESPONSE SENZA ERRORI");


      if (rememberMe) {
        localStorage.setItem('userid', userid);
        localStorage.setItem('password', password);
      } else {

        localStorage.removeItem('userid');
        localStorage.removeItem('password');
      }
      console.log("Vado a welcome");
      navigate(`/welcome`);
    }
  }


  return (

    <BasicLayout image={bgImage}>
       <Card sx={{ borderRadius: 4, boxShadow: "0 20px 50px rgba(0,0,0,0.35)", overflow: "visible" }}>
 
        <MDBox
   borderRadius="lg"
  mx={2}
  mt={-3}
  py={2.5}
  px={2}
  textAlign="center"
  sx={({ palette: { brand }, functions: { rgba } }) => ({
    backgroundColor: brand.main,
    boxShadow: `0 4px 20px 0 ${rgba("#000000", 0.14)}, 0 7px 10px -5px ${rgba(brand.main, 0.4)}`,
  })}
        >
    <MDTypography component="h1" variant="h4" fontWeight="bold" color="white" letterSpacing={3}>
        FARFIERA
      </MDTypography>
      <MDTypography variant="button" color="white" fontWeight="regular" opacity={0.9}>
        Accedi alla tua area riservata
      </MDTypography>

        </MDBox>
         <MDBox pt={3} pb={3} px={3}>
      {/* Logo */}
      <MDBox textAlign="center" mb={3}>
       <MDBox component="img" src={logo} alt="Umbria Fiere" width="100%" maxWidth="300px" />
      </MDBox>
 
        {/* Avviso 
        <MDBox display="flex" alignItems="center" gap={1.5}
  p={1.5}
  mb={3}
  borderRadius="lg"
  sx={({ palette: { brand }, functions: { rgba } }) => ({
    backgroundColor: rgba(brand.focus, 0.1),
    borderLeft: `4px solid ${brand.main}`,
  })}>
           <Icon aria-hidden="true" sx={({ palette: { brand } }) => ({ color: brand.main })}>campaign</Icon>
  <MDTypography variant="button" fontWeight="medium" sx={({ palette: { brand } }) => ({ color: brand.main })}>
    Le iscrizioni ad Agriumbria 2027 apriranno a breve!
  </MDTypography>
        </MDBox>*/}


      {/* Form: onSubmit permette di accedere anche premendo Invio */}
      <MDBox
        component="form"
        role="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleClickLogin(e);
        }}
      >
        <MDBox mb={2}>
          <MDInput
            type="text"
            color="success"
            label="Username o Email"
            fullWidth
            name="userid"
            autoComplete="username"
            value={userid}
            onChange={(e) => setUserid(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon fontSize="small" color="action">person</Icon>
                </InputAdornment>
              ),
            }}
          />
        </MDBox>
 
        <MDBox mb={1}>
          <MDInput
            type={showPwd ? "text" : "password"}
            color="success"
            label="Password"
            fullWidth
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon fontSize="small" color="action">lock</Icon>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPwd(!showPwd)}
                    edge="end"
                    size="small"
                    aria-label={showPwd ? "Nascondi password" : "Mostra password"}
                  >
                    <Icon fontSize="small">{showPwd ? "visibility_off" : "visibility"}</Icon>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </MDBox>
 
        {/* Ricordami + password dimenticata sulla stessa riga */}
        <MDBox display="flex" alignItems="center" justifyContent="space-between" ml={-1}>
          <FormControlLabel
            control={<Switch checked={rememberMe} onChange={handleSetRememberMe}   />}
            label={
              <MDTypography variant="button" fontWeight="regular" color="text">
                Ricordami
              </MDTypography>
            }
            sx={{ userSelect: "none", m: 0 }}
          />
          <Link to="/request_change_pwd">
            <MDTypography variant="button" fontWeight="medium" sx={({ palette: { brand } }) => ({ color: brand.main })}>
              Password dimenticata?
            </MDTypography>
          </Link>
        </MDBox>
 
        {error !== null && (
          <MDBox mt={2}>
            <Alert color="error" dismissible>
              <ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{error.message}
            </Alert>
          </MDBox>
        )}
 
        <MDBox mt={3} mb={1}>
          <MDButton
            type="submit"
            variant="contained"
          
            size="large"
            fullWidth
            sx={({ palette: { brand, white } }) => ({
    backgroundColor: brand.main,
    backgroundImage: "none",
    color: white.main,
    letterSpacing: 1.5,
    "&:hover, &:focus": { backgroundColor: brand.main, boxShadow: "0 6px 16px rgba(6,76,49,0.35)" },
    "&:focus-visible": { outline: `2px solid ${brand.focus}`, outlineOffset: "2px" },
  })}
          >
            ENTRA
          </MDButton>
        </MDBox>
 
        {/* Separatore */}
        <MDBox display="flex" alignItems="center" my={3}>
          <MDBox flex={1} height="1px" sx={({ palette: { grey } }) => ({ backgroundColor: grey[300] })} />
          <MDTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase" px={2}>
            Non hai un account?
          </MDTypography>
          <MDBox flex={1} height="1px" sx={({ palette: { grey } }) => ({ backgroundColor: grey[300] })} />
        </MDBox>
 
        {/* Registrazione */}
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <RegisterCard icon="storefront" who="'Azienda" action="Partecipa" to="/expo_register" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <RegisterCard icon="badge" who=" Visitatore" action="Registrati" to="/register" />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  </Card>
</BasicLayout>
  );
}

export default Basic;
